import cn from "@/util/cn";
import { ComponentPropsWithoutRef } from "react";

type BloodPressuresTableLegendProps = ComponentPropsWithoutRef<"div">;

const BloodPressuresTableLegend = ({
  className,
  ...otherProps
}: BloodPressuresTableLegendProps) => (
  <div className={cn("flex w-fit items-center gap-4 text-sm", className)} {...otherProps}>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-warning" />
      Low
    </div>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-acceptable" />
      Acceptable
    </div>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-warning" />
      Elevated
    </div>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-emergency" />
      Critical
    </div>
  </div>
);

type ColorIndicatorProps = ComponentPropsWithoutRef<"span">;

const ColorIndicator = ({ className, ...otherProps }: ColorIndicatorProps) => (
  <span
    className={cn("print-color-exact me-1 inline-block size-2 border border-gray-200 p-1", className)}
    {...otherProps}
  />
);

export default BloodPressuresTableLegend;
